module.exports = __webpack_public_path__ + "static/img/banner.677966b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/NewsDetails/banner.png
// module id = +IP6
// module chunks = 1